{
  "entity": {
    "user": {
      "fields": {
        "nickname": "Scout Name"
      }
    }
  },
  "global": {
    "language": "English (Scout)"
  }
}